<p>Importer une image</p>

<div class="form-group">
  <label for="fichier">Choisir un fichier</label>
  <input type="file" id="fichier" accept="image/*" (change)="envoiFichier($event.target.files)"/>
</div>

<img [src]="dataOut.edit ? dataOut.cover : 'assets/img/defLoad.png'" style="width: 80px; margin-top: 20px;" />

<mat-progress-spinner *ngIf="loading" class="mat-progress-spinner-coverupload" mode="indeterminate"></mat-progress-spinner>

<div mat-dialog-actions>
  <button mat-button (click)="closeDialog(false)">Annuler</button>
  <button mat-button (click)="closeDialog(true)">Valider</button>
</div>
